import { Box, Grid, Paper } from "@mui/material";
import BadgeFlotante from "./BadgeFlotante";
import FadeInImage from "./FadeInImage";

interface ImagenBadgeProps {
  t:(e:string)=>string;
  prefix:string;
}

export default function ImagenBadge({t,prefix}:ImagenBadgeProps) {

  return (
    <Grid size={{ xs: 12, lg: 6 }} sx={{ position: "relative" }}>
      <Box>
        <Paper
          elevation={0}
          sx={{
            p: 1,
            borderRadius: 8,
            border: "1px solid #e2e8f0",
            bgcolor: "white",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <FadeInImage
            src={t(`${prefix}.hero.image`)}
            alt="Hero Image"
            sx={{
              width: "100%",
              borderRadius: 7,
              display: "block",
              aspectRatio: "16/10",
              objectFit: "cover",
            }}
          />
        </Paper>

        {/* Badge flotante animado con CSS Nativo en el sx */}
        <BadgeFlotante t={t} prefix={prefix} />
      </Box>
    </Grid>
  );
}
